<template>
  <div id="app">
    <div class="app_wrapper" :id="$store.state.device == 'desktop' ? '' : 'mobile'">
      <!-- 只在非下载页面显示头部 -->
      <div class="header" :class="{ scrolled: isScrolled, 'header-scrolled': isHeaderScrolled }">
        <div class="wrap_center">
          <div style="display: flex; align-items: center;">
            <img class="logo"
              :src="isHeaderScrolled ? 'https://oss.jinchaoshuju.com/images/c8a97960-0ba3-46a1-a071-1d2cd4319f99.png' : 'https://oss.jinchaoshuju.com/images/fb663bec-e370-4fee-b92d-4ae4258dbf90.png'"
              style="width: 200px; padding: 10px 0 0 20px;" alt="" :class="{ 'logo-scrolled': isHeaderScrolled }" />
          </div>
          <!-- 移动端汉堡菜单按钮 -->
          <div class="mobile-menu-btn" @click="toggleMobileMenu" v-if="$store.state.device !== 'desktop'">
            <img style="width: 36px;"
              :src="isHeaderScrolled ? 'https://oss.jinchaoshuju.com/images/738d5fa1-a1d0-4556-a666-7695d1e0522d.png' : 'https://oss.jinchaoshuju.com/images/0ac26390-533f-493a-9233-2a37fdbb02bd.png'"
              alt="">
          </div>
          <div class="nav" ref="nav" :class="shownav ? 'navshow' : ''">
            <ul>
              <li v-for="item in navarr" :key="item.id" :class="[
                currentNav == item.id ? 'current animate__slideInDown' : '',
                { 'nav-scrolled': isHeaderScrolled }
              ]" @click="changeNav(item)">
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 移动端全屏菜单遮罩 -->
      <div class="mobile-menu-overlay" v-if="isMobileMenuOpen" @click="closeMobileMenu"></div>
      <div class="mobile-menu-popup" :class="{ open: isMobileMenuOpen }">
        <div class="mobile-menu-header">
          <div class="menu-logo">
            <img src="https://oss.jinchaoshuju.com/images/c8a97960-0ba3-46a1-a071-1d2cd4319f99.png" alt="Logo" />
          </div>
          <div class="close-btn" @click="closeMobileMenu">×</div>
        </div>
        <ul class="mobile-menu-list">
          <li v-for="item in navarr" :key="item.id" :class="{ active: currentNav === item.id }"
            @click="handleMobileNavClick(item)">
            {{ item.name }}
          </li>
        </ul>
      </div>
      <!-- 添加路由过渡效果 -->
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath" />
      </transition>
      <div class="footer">
        <div class="footer_top">
          <div class="footer_services">
            <div class="service_item">
              <div class="service_icon">📞</div>
              <div class="service_text">
                <h4>客服热线</h4>
                <p>400-626-1506</p>
              </div>
            </div>
            <div class="service_item">
              <div class="service_icon">✉️</div>
              <div class="service_text">
                <h4>邮箱支持</h4>
                <p>amiweshi@163.com</p>
              </div>
            </div>
            <div class="service_item">
              <div class="service_icon">📍</div>
              <div class="service_text">
                <h4>公司地址</h4>
                <p>河北省保定市高新区华安保定高新数智谷9号楼2单元</p>
              </div>
            </div>
          </div>
        </div>
        <div class="footer_bottom">
          <div class="company_info">
            <div class="contact_info">
              <p>保定金巢数据科技有限公司</p>
              <p>地址: 河北省保定市高新区华安保定高新数智谷9号楼2单元</p>
              <a class="beian_link" href="https://beian.miit.gov.cn/" target="_blank">
                备案号：
                <img style="margin-right: 5px;" src="https://oss.jinchaoshuju.com/images/08dc0732-124a-4ab6-9e54-7e49482d6b3e.png"
                  alt="">冀ICP备2022023174号-8
              </a>
            </div>
          </div>
          <div class="qr_codes">
            <div class="qr_group">
              <div class="qr_item">
                <div class="qr_placeholder">
                  <img src="./assets/images/xiao_qrcode.png" alt="微信小程序" />
                </div>
                <p>微信小程序</p>
              </div>
            </div>
            <div class="qr_group">
              <div class="qr_item">
                <div class="qr_placeholder">
                  <img src="./assets/images/fu_qrcode.jpg" alt="微信服务号" />
                </div>
                <p>微信服务号</p>
              </div>
            </div>
            <div class="qr_group">
              <div class="qr_item">
                <div class="qr_placeholder">
                  <img src="./assets/images/pan.png" alt="商务合作" />
                </div>
                <p>商务合作</p>
              </div>
            </div>
          </div>
        </div>
        <div class="footer_copyright">
          <p>&copy; 2026 金巢数据 - 共创生态布局 同享价值创造</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ResizeMixin from "../src/ResizeHandler";
import alldata from "./views/alldata";

export default {
  name: "app",
  data() {
    return {
      alldata: null,
      navarr: [
        { id: 1, name: "首页", url: "/home" },
        { id: 2, name: "解决方案", url: "/product" },
        { id: 3, name: "应用场景", url: "/business" },
        { id: 6, name: "新闻中心", url: "/news" },
        { id: 5, name: "关于我们", url: "/Course" },
      ],
      currentNav: 1,
      shownav: false,
      isScrolled: false,
      isHeaderScrolled: false,
      scrollTimer: null,
      isMobileMenuOpen: false, // 新增移动端菜单状态
    };
  },
  mixins: [ResizeMixin],
  computed: {},
  watch: {
    $route: {
      handler(to) {
        this.updateCurrentNav(to);
      },
      immediate: true
    },
  },
  mounted() {
    this.alldata = alldata;
    this.initCurrentNav();
    window.addEventListener("scroll", this.handleScrollDebounce);

    // 监听设备变化
    this.$store.watch(
      state => state.device,
      (newDevice) => {
        if (newDevice === 'desktop') {
          this.isMobileMenuOpen = false;
        }
      }
    );
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScrollDebounce);
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
    }
  },
  methods: {
    initCurrentNav() {
      const savedNav = sessionStorage.getItem("currentNav");
      if (savedNav) {
        this.currentNav = parseInt(savedNav);
      } else {
        this.currentNav = 1;
      }
      this.$nextTick(() => {
        try {
          const targetRoute = this.navarr.find(item => item.id === this.currentNav);
          if (targetRoute && this.$route.path !== targetRoute.url) {
            this.$router.replace(targetRoute.url);
          }
        } catch (err) {
          console.warn('路由初始化失败:', err);
        }
      });
    },

    updateCurrentNav(route) {
      if (route.path.includes("/mirror/")) {
        this.currentNav = 0;
        sessionStorage.setItem("currentNav", 0);
      } else {
        const navItem = this.navarr.find((item) => item.url === route.path);
        if (navItem) {
          this.currentNav = navItem.id;
          sessionStorage.setItem("currentNav", navItem.id);
        }
      }
    },

    async changeNav(data) {
      if (this.currentNav === data.id) return;
      this.currentNav = data.id;
      sessionStorage.setItem("currentNav", data.id);
      this.shownav = false;
      try {
        await this.$router.push(data.url);
      } catch (err) {
        console.error('路由跳转失败:', err);
        window.location.href = data.url;
      }
    },

    // 新增移动端菜单相关方法
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },

    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },

    async handleMobileNavClick(item) {
      if (this.currentNav === item.id) {
        this.closeMobileMenu();
        return;
      }

      this.currentNav = item.id;
      sessionStorage.setItem("currentNav", item.id);
      this.closeMobileMenu();

      try {
        await this.$router.push(item.url);
      } catch (err) {
        console.error('移动端路由跳转失败:', err);
        window.location.href = item.url;
      }
    },

    shownavlist() {
      this.shownav = true;
    },

    closeNav() {
      this.shownav = false;
    },

    handleScrollDebounce() {
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }
      this.scrollTimer = setTimeout(() => {
        this.handleScroll();
      }, 100);
    },

    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.isScrolled = scrollTop > 50;
      this.isHeaderScrolled = scrollTop > 50;
    },
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.header {
  height: 80px !important;
  background: transparent;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  transition: all 0.3s ease;

  &.scrolled {
    background: #ffffff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  img {
    transition: opacity 0.3s ease;
  }

  .logo-scrolled {
    opacity: 1;
  }

  .wrap_center {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  h1 img {
    width: 167px;
    transition: filter 0.3s ease;
  }

  .ivu-icon.ivu-icon-md-menu {
    display: none;
  }

  .nav ul {
    display: flex;
    justify-content: space-between;
    list-style: none;

    li {
      margin: 10px 20px;
      padding: 10px 0;
      font-size: 20px;
      text-align: center;
      cursor: pointer;
      color: #ffffff; // 默认白色文字
      transition: all 0.3s ease;

      &.nav-scrolled {
        color: #333333; // 滚动后变为深色文字
      }
    }

    li.current {
      color: #2a89f7;
      font-weight: bold;
      border-bottom: 2px solid #2a89f7;
    }
  }
}

.footer {
  background: #1e2126; // 深色背景
  color: #fff;
  padding-top: 40px;

  .footer_top {
    padding-bottom: 30px;
    width: 80%;
    margin: 20px auto;

    .footer_services {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      gap: 20px;

      .service_item {
        display: flex;
        align-items: center;
        flex: 1;
        min-width: 200px;
        padding: 15px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        transition: transform 0.3s ease, background 0.3s ease;

        &:hover {
          transform: translateY(-5px);
          background: rgba(255, 255, 255, 0.15);
        }

        .service_icon {
          font-size: 24px;
          margin-right: 15px;
        }

        .service_text {
          h4 {
            color: #ffffff;
            margin-bottom: 5px;
            font-size: 16px;
          }

          p {
            color: #ffffff;
            font-size: 14px;
          }
        }
      }
    }
  }

  .footer_bottom {
    padding: 40px 0 30px;
    display: flex;
    justify-content: space-around;

    .company_info {
      display: flex;
      flex-direction: column;
      gap: 25px;

      .logo_section {
        h2 {
          color: #ffffff;
          font-size: 24px;
          margin-bottom: 10px;
        }

        p {
          color: #ffffff;
          font-size: 14px;
        }
      }

      .contact_info {
        p {
          color: #ffffff;
          margin-bottom: 10px;
          font-size: 14px;
          line-height: 1.5;
        }

        .beian_link {
          color: #ffffff;
          text-decoration: none;
          font-size: 13px;
          display: flex;
          align-items: center;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    .qr_codes {
      display: flex;

      .qr_group {
        margin-left: 20px;
        display: flex;
        gap: 25px;
      }

      .qr_item {
        text-align: center;

        .qr_placeholder {
          width: 100px;
          height: 100px;
          background: #ffffff;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 36px;
          margin: 0 auto 10px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        p {
          color: #e8f5e9;
          font-size: 14px;
          margin: 0;
        }
      }
    }
  }

  .footer_copyright {
    background: #15171a; // 更深的背景色
    padding: 15px 0;
    text-align: center;

    p {
      color: #ffffff;
      font-size: 14px;
      margin: 0;
    }
  }

  // 响应式适配
  @media (max-width: 768px) {
    .footer_top {
      .footer_services {}
    }

    .footer_bottom {
      flex-direction: column;
      gap: 30px;
      text-align: center;

      .qr_codes {
        justify-content: center;
      }
      .beian_link {
        color: #ffffff;
        text-decoration: none;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

// 添加路由过渡动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 移动端汉堡菜单样式
@media (max-width: 992px) {
  .header {
    height: 55px !important;
  }

  .wrap_center {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo {
      width: 120px !important;
      padding: 0 0 0 10px !important;
    }
  }

  .mobile-menu-btn {
    display: flex;
    align-items: center;
    padding: 10px;
    cursor: pointer;
    z-index: 1001;

    .hamburger {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      width: 25px;
      height: 20px;

      span {
        display: block;
        height: 3px;
        width: 100%;
        background: #333;
        border-radius: 2px;
        transition: all 0.3s ease;

        &:nth-child(1) {
          transform-origin: top left;
        }

        &:nth-child(3) {
          transform-origin: bottom left;
        }
      }

      &.open {
        span:nth-child(1) {
          transform: rotate(45deg) translate(5px, -5px);
        }

        span:nth-child(2) {
          opacity: 0;
        }

        span:nth-child(3) {
          transform: rotate(-45deg) translate(5px, 5px);
        }
      }
    }
  }

  // 移动端菜单弹窗
  .mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    backdrop-filter: blur(3px);
  }

  .mobile-menu-popup {
    position: fixed;
    top: 0;
    right: -300px;
    width: 280px;
    height: 100vh;
    background: #fff;
    z-index: 1000;
    transition: right 0.3s ease;
    box-shadow: -2px 0 15px rgba(0, 0, 0, 0.2);

    &.open {
      right: 0;
    }

    .mobile-menu-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      border-bottom: 1px solid #eee;

      .menu-logo {
        img {
          height: 30px;
        }
      }

      .close-btn {
        font-size: 24px;
        font-weight: bold;
        color: #666;
        cursor: pointer;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;

        &:hover {
          background: #f5f5f5;
        }
      }
    }

    .mobile-menu-list {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        padding: 15px 20px;
        font-size: 16px;
        color: #333;
        border-bottom: 1px solid #f0f0f0;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
          background: #f8f9fa;
          padding-left: 25px;
        }

        &.active {
          background: #2a89f7;
          color: #fff;
          font-weight: bold;

          &:hover {
            background: #1a6fc4;
          }
        }
      }
    }
  }

  // 隐藏原有的移动端菜单样式
  .nav {
    display: none !important;
  }
}

// 桌面端保持原有样式
@media (min-width: 993px) {
  .mobile-menu-btn {
    display: none !important;
  }

  .mobile-menu-popup,
  .mobile-menu-overlay {
    display: none !important;
  }
}
</style>